module.exports = {
  annotate: require(74).annotate,
  Module: require(77),
  Injector: require(76)
};
